import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';

function createData(
    id,
    title,
    code, type, dimensions, price, exhibitor, status,


) {
    return { id, title, code, type, dimensions, price, exhibitor, status };
}



const rows = [
    createData(1, "ssss ipsum dolor sit amet, ", '01', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(2, "ssss ipsum dolor sit amet, ", '09', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(3, "ssss ipsum dolor sit amet, ", '07', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(4, "ssss ipsum dolor sit amet, ", '08', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(5, "ssss ipsum dolor sit amet, ", '05', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(6, "ssss ipsum dolor sit amet, ", '09', 'squir', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(7, "ssss ipsum dolor sit amet, ", '07', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(8, "ssss ipsum dolor sit amet, ", '11', 'circle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(9, "ssss ipsum dolor sit amet, ", '41', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(10, "ssss ipsum dolor sit amet, ", '51', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(11, "ssss ipsum dolor sit amet, ", '21', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(12, "ssss ipsum dolor sit amet, ", '31', 'Round', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(13, "ssss ipsum dolor sit amet, ", '41', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),


].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const ManageConferenceParticpant = () => {
    const history = useHistory();
    //const [page, setPage] = useState(0);
    //const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = React.useState(() => {
        return parseInt(localStorage.getItem('tablePage')) || 0;
    })
    const [rowsPerPage, setRowsPerPage] = React.useState(() => {
        return parseInt(localStorage.getItem('tableRowsPerPage')) || 10;
    });
    const [searchText, setSearchText] = useState('');

    const [permissions, setrPermissions] = useState([]);
    const [allData, setAllData] = useState([]);
    const [participantIndex, setParticipantIndex] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
    React.useEffect(() => {
        return () => {
            setAllData(rows)
        };
    }, []);
    const eventid = localStorage.getItem('eventid')
    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);



    React.useEffect(() => {
        axios.get(`api/conference-category-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const ccategoryData = res.data.conferenceCategories;
                setConferenceCategoryData(ccategoryData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);



    React.useEffect(() => {
        axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const cpartiticpantData = res.data.cpindex;
                setParticipantIndex(cpartiticpantData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, [selectedFile]);





    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleFileUpload = () => {

        axios.get('/sanctum/csrf-cookie')
            .then(() => {
                // Once CSRF token is obtained, create FormData and append the file
                const formData = new FormData();
                formData.append('file', selectedFile);

                // Send the FormData to the server
                axios.post(`/api/conference-particpant-csv-upload/${eventid}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data' // Set appropriate content type
                    }
                })
                    .then(res => {
                        if (res.data.status === 200) {

                            const messageWithCount = `${res.data.message} ${res.data.record_count} records imported.`;
                            swal('Success', messageWithCount, 'success');
                            setSelectedFile(null);
                            document.getElementById('contained-button-file').value = '';
                            history.push('/admin/conference/manage-particpant');

                        } else {
                            swal('Error', 'File not uploaded1', 'error');

                        }
                    })
                    .catch(error => {
                        console.error('Error uploading file:', error);
                        swal('Error', 'File not uploaded2', 'error');
                    })
            })
            .catch(error => {
                console.error('Error fetching CSRF token:', error);

            });
    };


    const conferenceCategFilterData = conferenceCategoryData.map(item => ({
        ID: item.id,
        category_name: item.conference_category_title

    }));

    const downloadCsvSample = () => {
        const data = [
            ["conference_category_id", "name_title", "participant_name", "participant_saudi_council_no", "participant_email", "participant_gender", "participant_profession", "participant_phone_number", "participant_country", "participant_city", "participant_address", "participant_company"],
            [1, "Mr", "John", "0000", "john@test.com", '0', "doctor", "05123456", "Saudi Arabia", "Al Riyadh", "Al Riyadh", "CompanyName"],
            [1, "Ms", "Lily", "0000", "lily@test.com", '1', "doctor", "05123456", "Saudi Arabia", "Al Riyadh", "Al Riyadh", "CompanyName"],
            ["", "", "", "", "", "", "", "", "", "", "", ""],
            ["", "", "", "", "", "", "", "", "", "", "", ""],
            ["note: These are the ID of each category but before uploading remove this section"],
            ["ID", "category_name"],
            ...conferenceCategFilterData.map(row => [row.ID, row.category_name]),
            ["", "", "", "", "", "0 for male , 1 for female", "", "", "", "", "", ""],
        ];
        const csvContent = data.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Import-Conference-Sample.csv';
        link.click();
    };


    const CustomFieldDelete = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = " Deleting..."
        axios.get(`api/status-list-customfield/${id}`).then(res => {
            if (res.data.status === 200) {
                //swal("Success", res.data.message, "success");
                thisClicked.closest("tr").remove();
            }
            else if (res.data.status === 404) {
                this.innText = "delete";
            }
        });
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        localStorage.setItem('tablePage', newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0); // usually reset to first page when rows per page changes
        localStorage.setItem('tableRowsPerPage', newRowsPerPage);
        localStorage.setItem('tablePage', 0);
    };
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };



    const filteredRows = rows.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const [searchTerm, setSearchTerm] = useState('');
    const filteredPosts = participantIndex.filter((row) =>

        //(row.phone && row.phone.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.participant_name && row.participant_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.participant_email && row.participant_email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.participant_saudi_council_no && row.participant_saudi_council_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.participant_phone_number && row.participant_phone_number.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.wpjoin_as && row.wpjoin_as.join_as && row.wpjoin_as.join_as.toLowerCase().includes(searchTerm.toLowerCase()))
        //(row.role && row.role.toLowerCase().includes(searchTerm.toLowerCase()))
        // Add more fields with null checks as needed
    );
    const totalRecords = participantIndex.length;
    const filteredRecordsCount = filteredPosts.length;



    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,


    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    {
                        permissions['p_conference-participant-add'] === true ?

                            <Button sx={{
                                float: 'right',
                                marginRight: '1%',
                                marginTop: '2%',
                                backgroundColor: backGroundButtonByEvent,
                                ":hover": {
                                    color: "white"
                                }
                            }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                //to="/admin/conference/join-as"
                                to="/admin/conference/add-particpant">
                                Add New
                            </Button> : ""}
                </h4>

                <Card sx={{ width: '85vw', float: 'center' }} >
                    <CardContent >

                        <Box component="form" noValidate sx={{ mt: 3 }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography component="h1" variant="h5">
                                    Manage Conference Participant
                                </Typography>
                                <Typography>
                                    Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
                                </Typography>
                                <Grid container spacing={2} alignItems="center" justifyContent="flex-end">

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Filter By: Name , Email , Mobile No , Saudi Council No , Join As"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </Grid>
                                    {
                                        permissions['p_conference-participant-import'] === true ?
                                            <Grid item xs={6} sm={3} md={3}>
                                                {/* <input type="file" onChange={handleFileChange} id="contained-button-file"  /> */}
                                                <TextField id="contained-button-file" multiple type="file" onChange={handleFileChange} />
                                            </Grid> : ""}
                                    {
                                        permissions['p_conference-participant-import'] === true ?
                                            <Grid item xs={6} sm={3} md={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleFileUpload}
                                                    disabled={!selectedFile} // Disable button if no file selected
                                                    sx={{ backgroundColor: backGroundButtonByEvent, }}>
                                                    Import File
                                                </Button>
                                            </Grid> : ""}
                                    {
                                        permissions['p_conference-participant-import'] === true ?
                                            <Grid item xs={6} sm={3} md={2}>
                                                <Button variant="contained" color="secondary" onClick={downloadCsvSample} sx={{ backgroundColor: backGroundButtonByEvent, }}>
                                                    Export Sample
                                                </Button>
                                            </Grid> : ""}
                                </Grid>
                            </div>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell > #</TableCell>
                                            <TableCell align="left">Name</TableCell>
                                            <TableCell align="left">Email</TableCell>
                                            <TableCell align="left">Mobile No</TableCell>
                                            <TableCell align="left">Saudi council no</TableCell>
                                            <TableCell align="left">Coupon code</TableCell>
                                            <TableCell align="left">Conference</TableCell>
                                            <TableCell align="left">Join As</TableCell>
                                            <TableCell align="left">Action</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {filteredPosts && filteredPosts.slice(startIndex, endIndex).map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.id}</TableCell>
                                                <TableCell>{row.name_title}: {row.participant_name}</TableCell>
                                                <TableCell>{row.participant_email}</TableCell>
                                                <TableCell>{row.participant_phone_number}</TableCell>
                                                <TableCell>{row.participant_saudi_council_no}</TableCell>
                                                <TableCell>
                                                    {row.cpcoupon && row.cpcoupon.length > 0 && (
                                                        row.cpcoupon.map((rowCoupon, couponIndex) => (
                                                            <div key={couponIndex}>{rowCoupon.coupon_code}</div>
                                                        ))
                                                    )}
                                                </TableCell>

                                                <TableCell style={{ width: '20%' }}>
                                                    {row.cpconference && row.cpconference.length > 0 && (
                                                        row.cpconference.map((rowConference, index) => (
                                                            <div key={index}>
                                                                {rowConference.conference_name}
                                                                {rowConference.conference_day ? ` : ${rowConference.conference_day}` : null}
                                                                {/* {rowConference.conference_day && ` : ${rowConference.conference_day}`} */}
                                                            </div>
                                                            //<div key={index}>{rowConference.conference_name} , {rowConference.conference_day}</div>
                                                        ))
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {row.cpjoin_as && row.cpjoin_as.join_as ? row.cpjoin_as.join_as : "Participant"}
                                                </TableCell>

                                                <TableCell>
                                                    {permissions['p_conference-participant-edit'] === true && (
                                                        <Button
                                                            sx={{
                                                                margin: 1,
                                                                ":hover": {
                                                                    color: "white"
                                                                },
                                                                backgroundColor: backGroundButtonByEvent,
                                                            }}
                                                            color='primary'
                                                            size='small'
                                                            variant='contained'
                                                            component={Link}
                                                            to={`/admin/conference/eidt-particpant/${row.id}`}
                                                        >
                                                            Edit Conference
                                                        </Button>
                                                    )}
                                                    {/* {permissions['p_conference-participant-delete'] === true && (
                                                        <Button
                                                            sx={{
                                                                margin: 1,
                                                                ":hover": {
                                                                    color: "white"
                                                                },
                                                                backgroundColor: backGroundButtonByEvent,
                                                            }}
                                                            color='primary'
                                                            size='small'
                                                            variant='contained'
                                                            onClick={(e) => CustomFieldDelete(e, row.id)}
                                                        >
                                                            <DeleteIcon />
                                                        </Button>
                                                    )} */}
                                                    {permissions['p_conference-participant-edit-information'] === true && (
                                                        <Button
                                                            sx={{
                                                                margin: 1,
                                                                ":hover": {
                                                                    color: "white"
                                                                },
                                                                backgroundColor: backGroundButtonByEvent,
                                                            }}
                                                            color='primary'
                                                            size='small'
                                                            variant='contained'
                                                            component={Link}
                                                            to={`/admin/conference/basic-particpant/${row.id}`}
                                                        >
                                                            Edit Participant..
                                                        </Button>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                {/* <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000, 10000, 100000,]}
                                    component="div"
                                    count={filteredRows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000, 10000, 100000]}
                                    component="div"
                                    count={filteredRows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />


                            </TableContainer>

                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default ManageConferenceParticpant;
